import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import { get } from 'lodash'
import { ElevatedBox, Card } from 'components/layout'
import { ActivityBadge } from 'components/sections/dashboard'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'
import styles from './section-card.styl'
import BadgeCollection from '../../../../containers/misc/BadgeCollection/BadgeCollection'

export default class SectionCard extends Component {
  static propTypes = {
    caption: PropTypes.any,
    title: PropTypes.any,
    showProgress: PropTypes.bool,
    onWarningClick: PropTypes.func,
    onClick: PropTypes.func,
    completedPercentage: PropTypes.number,
    activityProgress: PropTypes.object,
    sectionIcon: PropTypes.object,
    activitySection: PropTypes.string,
    returnedByAssessor: PropTypes.bool,
    isBadgesEnabled: PropTypes.bool,
    awardBadges: PropTypes.object,
    awardLevel:PropTypes.object
  }

  static defaultProps = {
    showProgress: false
  }

  render() {
    const {
      title,
      caption,
      onClick,
      sectionIcon,
      showProgress,
      activitySection,
      activityProgress,
      completedPercentage,
      returnedByAssessor,
      isBadgesEnabled,
      awardBadges,
      awardLevel
    } = this.props

    const returnedByText = returnedByAssessor ? (
      <FormattedHTMLMessage
        id="label.activity_rejected_click_by_assessor"
        defaultMessage="Your activity has been rejected by Award Leader.<br /> Click for "
      />
    ) : (
      <FormattedHTMLMessage
        id="label.activity_rejected_click"
        defaultMessage="Your activity has been rejected by Award Leader.<br /> Click for "
      />
    )

    return (
      <div className={styles[getActivityClassName(activitySection)]}>
        <ElevatedBox onClick={onClick} clickable>
          <Card.Wrap>
            <Card.Left>
              <div className={styles.badge}>
                <ActivityBadge activitySection={activitySection} small />
              </div>
            </Card.Left>

            <Card.Content>
              <Card.Top>
                <Card.Middle>
                  <h3 className={styles.title}>{title}</h3>

                  <p className={styles.caption}>{caption}</p>
                </Card.Middle>

                <Card.Right>

                  <div className={styles.sectionIcon}>

                  {isBadgesEnabled && <BadgeCollection awardLevel={awardLevel} awardBadges={awardBadges} activitySection={activitySection} />}

                    {get(sectionIcon, 'pending') && (
                      <i style={{ marginLeft: '8px' }} className="ico ico--update" />
                    )}


                    {get(sectionIcon, 'add') && <i style={{ marginLeft: '8px' }} className="ico ico--add" />}

                    {get(sectionIcon, 'checked') && (
                      <i style={{ marginLeft: '8px' }} className="ico ico--checked" />
                    )}
                    {get(sectionIcon, 'percent') && (
                      <span style={{ marginLeft: '8px' }} className={styles.percentage}>
                        {completedPercentage}
                        <span className={styles.percentageSymbol}> %</span>
                      </span>
                    )}
                  </div>
                </Card.Right>
              </Card.Top>

              {showProgress && (
                <Card.Bottom className={styles.progress}>
                  {activityProgress}
                </Card.Bottom>
              )}
            </Card.Content>
          </Card.Wrap>
        </ElevatedBox>
        {get(sectionIcon, 'warning') && (
          <div className={styles.warning}>
            <i className={`ico ico--warning ${styles.warningIcon}`} />
            {returnedByText}
            <span
              className={styles.warningLink}
              onClick={this.props.onWarningClick}
            >
              <FormattedMessage
                id="button.more_information"
                defaultMessage="more information"
              />
            </span>
          </div>
        )}
      </div>
    )
  }
}
